module.exports = __webpack_public_path__ + "img/bgApps.16703050.jpg";